<div id="footer-1" class="diag-wrapper">
    <div class="diagonal wf-section">
        <div class="div-block-2"></div>
    </div>
    <div class="wf-section"></div>
    <div class="columns-6 w-row">
        <div class="w-col w-col-2"></div>
        <div class="w-col w-col-4">
            <p class="paragraph-2"><br>fortega@smarttec.info<br>022263439 / 0996087115<br>Av. de los Shirys N39-94 y El
                Telégrafo<br>Quito - Ecuador<br>‍<br></p>
        </div>
        <div class="w-col w-col-1"></div>
        <div class="w-col w-col-3"><img src="assets/images/logo-st.svg" loading="lazy" alt="" class="image-33">
            <p *ngIf="sitio=='EasyMed'" class="paragraph-2 letra12">Derechos reservados. EasyMed y Smarttec son marcas registradas de Smarttec Cía. Ltda.<br></p>
            <p *ngIf="sitio=='Efisys'" class="paragraph-2 letra12">Derechos reservados. Efisys y Smarttec son marcas registradas de Smarttec Cía. Ltda.<br></p>
        </div>
        <div class="w-col w-col-2"></div>
    </div>
</div>
